export default __webpack_public_path__ + "static/media/flag-canada-2x.18989d05.png";